import { Box } from '@color/continuum';
import { useFormikContext } from 'formik';

import { AutocompleteField } from 'ui/common/components/FormFields/FormikAutocompleteField';

import { useVariantEffectFilterValues } from '../../apis';
import { IVariantClassificationListParams } from '../../types';

const VEP_CONSEQUENCE_FIELD_WIDTH = '320px';

export const VariantEffectFields = () => {
  const { values, setFieldValue } = useFormikContext<IVariantClassificationListParams>();
  const { data, isFetching } = useVariantEffectFilterValues();

  return (
    <Box sx={{ width: VEP_CONSEQUENCE_FIELD_WIDTH }}>
      <AutocompleteField
        name="vepConsequence"
        label="Variant Consequence"
        multiple
        disableCloseOnSelect
        options={data?.results ?? []}
        loading={isFetching}
        value={values.vepConsequence ? values.vepConsequence.split(',').filter(Boolean) : []}
        onChange={(selectedConsequences) => {
          setFieldValue('vepConsequence', selectedConsequences.join(','));
        }}
        optionalIndicatorIsEnabled={false}
      />
    </Box>
  );
};
